import React, { useEffect } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { setIsMobile } from 'store/Layout';

export const LayoutInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile]);

  return <>{children}</>;
};